/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Execute_Detail7Inputs */

const en_svc_mobile_app_development_execute_detail7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Core features first, platform-specific polish second, real-device tested.`)
};

const ar_svc_mobile_app_development_execute_detail7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الميزات الأساسية أولًا وصقل خاص بالمنصة ثانيًا واختبار على أجهزة حقيقية.`)
};

const bn_svc_mobile_app_development_execute_detail7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আগে কোর ফিচার, পরে প্ল্যাটফর্ম-নির্দিষ্ট পলিশ, রিয়েল ডিভাইসে টেস্টেড।`)
};

const de_svc_mobile_app_development_execute_detail7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erst die Kernfunktionen, dann der plattformspezifische Feinschliff, getestet auf echten Geräten.`)
};

const es_svc_mobile_app_development_execute_detail7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones principales en primer lugar, pulido específico de la plataforma en segundo lugar, probado en dispositivos reales.`)
};

const fr_svc_mobile_app_development_execute_detail7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D'abord les fonctionnalités de base, puis la finition spécifique à la plateforme, testé sur appareils réels.`)
};

const pt_svc_mobile_app_development_execute_detail7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos principais primeiro, depois polimento específico da plataforma, testado em dispositivos reais.`)
};

const zh_svc_mobile_app_development_execute_detail7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核心功能第一，平台特定的完善第二，真实设备测试。`)
};

const tr_svc_mobile_app_development_execute_detail7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önce ana özellikler, sonra platforma özel rötuşlar, gerçek cihazda testli.`)
};

const ru_svc_mobile_app_development_execute_detail7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сначала основные функции, затем доработка под конкретную платформу, тестирование на реальных устройствах.`)
};

const pl_svc_mobile_app_development_execute_detail7 = /** @type {(inputs: Svc_Mobile_App_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najpierw funkcje core'owe, potem dopracowanie pod platformę, testy na żywych urządzeniach.`)
};

/**
* | output |
* | --- |
* | "Core features first, platform-specific polish second, real-device tested." |
*
* @param {Svc_Mobile_App_Development_Execute_Detail7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_execute_detail7 = /** @type {((inputs?: Svc_Mobile_App_Development_Execute_Detail7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Execute_Detail7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_execute_detail7(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_execute_detail7(inputs)
	if (locale === "de") return de_svc_mobile_app_development_execute_detail7(inputs)
	if (locale === "es") return es_svc_mobile_app_development_execute_detail7(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_execute_detail7(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_execute_detail7(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_execute_detail7(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_execute_detail7(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_execute_detail7(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_execute_detail7(inputs)
	return en_svc_mobile_app_development_execute_detail7(inputs)
});
export { svc_mobile_app_development_execute_detail7 as "svc_mobile-app-development_EXECUTE_detail" }